import { TileSizes } from '@ad-lucy/components/layout/Grid/TileSizeContext';
import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid2x2x2 = (): GridInterface[] =>
  defineGrid('2:2:2', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
            },
            {
              tileId: 3,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 4,
              tileSize: TileSizes['400x400'],
            },
            {
              tileId: 5,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 1/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 2/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 3,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 4,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 5,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 1/3',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 2/3',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 3,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 3/3',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 4,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 5,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
  ]);
